// extracted by mini-css-extract-plugin
export default {"admin":"index-module--admin--b2950","photos":"index-module--photos--fc348","save":"index-module--save--f08af","inner":"index-module--inner--b2a4b"};